import { render, staticRenderFns } from "./order-handle.vue?vue&type=template&id=2fb65c4d"
import script from "./order-handle.vue?vue&type=script&lang=js"
export * from "./order-handle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports